import ACTION_TYPES from "../actions/type.action";

const initialState = {
  posts: [],
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ACTION_TYPES.GETALL_POSTS:
      return {
        ...state,
        posts: payload,
      };
    case ACTION_TYPES.CLEARALL_POSTS:
      return {
        ...state,
        posts: [],
      };
    case ACTION_TYPES.UPDATE_POST:
      const EditedPostIndex = state.posts.findIndex(
        (post) => post.id === payload.postId,
      );
      let allPosts = [...state.posts];
      let editedPost = allPosts[EditedPostIndex];
      editedPost.text = payload.text;
      editedPost.edited = true;
      allPosts[EditedPostIndex] = editedPost;
      return {
        ...state,
        posts: [...allPosts],
      };
    case ACTION_TYPES.DELETE_POST:
      let getAllPosts = [...state.posts];
      let remainingPosts = getAllPosts.filter((post) => post.id !== payload);
      return {
        ...state,
        posts: [...remainingPosts],
      };
    case ACTION_TYPES.ADD_POST_BYNOTIFICATION:
      let newposts = [...state.posts];
      return {
        ...state,
        posts: [payload, ...newposts],
      };
    case ACTION_TYPES.CREATE_COMMENT:
    case ACTION_TYPES.UPDATE_COMMENT:
    case ACTION_TYPES.DELETE_COMMENT:
    case ACTION_TYPES.NOTIFICATION_UPDATE:
      const createPostIndex = state.posts.findIndex(
        (post) => post.id === payload.id,
      );
      let commentPosts = [...state.posts];
      commentPosts[createPostIndex] = payload;
      return {
        ...state,
        posts: [...commentPosts],
      };
    default:
      return state;
  }
};

export default reducer;
